export default __webpack_public_path__ + "static/media/dog_grooming_24x.ecbc9725.svg";